import moment from "moment";

import template from "./pPowerUserView.html";
import { cloneDeep } from "lodash";

export function pPowerUserViewDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pPowerUserViewController,
    controllerAs: 'pPowerUserView',
    bindToController: true
  };

  return directive;
}

const manuallyProjectsFlag = "ProjectsSetManually";
const erpProjectsFlag = "ProjectsFromErpSystem";
const manuallyProjectsSource = "AddedManually";
const erpProjectsSource = "Caseman";

class pPowerUserViewController {
  constructor ($filter, $scope, $interval, Auth, DownloadFile, Stats, Work, bModal, OvertimeApplications, Notes, ConnectionQuality, $translate, $q) {
    'ngInject';

    this.$filter = $filter;
    this.Auth = Auth;
    this.DownloadFile = DownloadFile;
    this.Stats = Stats;
    this.Work = Work;
    this.OvertimeApplications = OvertimeApplications;
    this.bModal = bModal;
    this.$translate = $translate;
    this.OvertimeApplications = OvertimeApplications;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$q = $q;
    this.$scope = $scope;

    this.headers = [
      {name: "STATS.CLIENT_NAME", class: "table-info"},
      {id: "projectName", name: "WORK_DATA.PROJECT", class: "table-info"},
      {name: "PROCESS_GROUP", class: "table-info"},
      {name: "PROCESS", class: "table-info table-process"},
      {name: "WORK_DATA.START_DATE", class: "table-date"},
      {name: "WORK_DATA.START_TIME", class: "table-time"},
      {name: "WORK_DATA.DURATION", class: "table-time"},
      {name: "WORK_DATA.VA", class: "table-short"},
      {name: "WORK_DATA.VOLUME", class: "table-number"},
      {name: "WORK_DATA.ADDED_MANUALLY", class: "table-short"},
      {name: "WORK_DATA.COMMENT", class: "table-comment"},
      {name: "WORK_DATA.INVOICE_DETAILS", class: "table-comment"},
      {name: null, class: "table-actions"},
      {name: null, class: null}
    ];

    this.worklogsTableUnsortedHeaders = [
      {
        id: "processGroupCountryConfigurationName",
        name: this.$translate.instant("PROCESS_GROUP"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.PROCESS_GROUP"),
        class: "table-info"
      },
      {
        id: "processName",
        name: this.$translate.instant("PROCESS"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.PROCESS"),
        class: "table-info table-process"
      },
      {
        id: "startDate",
        name: this.$translate.instant("WORK_DATA.START_DATE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.DATE"),
        class: "table-date"
      },
      {
        id: "startTime",
        name: this.$translate.instant("WORK_DATA.START_TIME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.START_TIME"),
        class: "table-time"
      },
      {
        id: "duration",
        name: this.$translate.instant("WORK_DATA.DURATION"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.DURATION"),
        class: "table-time"
      },
      {
        id: "va",
        name: this.$translate.instant("WORK_DATA.VA"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.VALUE_ADDED"),
        class: "table-short"
      },
      {
        id: "volume",
        name: this.$translate.instant("WORK_DATA.VOLUME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.VOL"),
        class: "table-number"
      },
      {
        id: "addedManually",
        name: this.$translate.instant("WORK_DATA.ADDED_MANUALLY"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.ADDED_MAN"),
        class: "table-short"
      },
      {
        id: "comment",
        name: this.$translate.instant("WORK_DATA.COMMENT"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.COMMENT"),
        class: "table-comment"
      },
      {
        id: "invoiceDetails",
        name: this.$translate.instant("WORK_DATA.INVOICE_DETAILS"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.INVOICE_DETAILS"),
        class: "table-comment"
      }
    ];

    this.state = "loading";
    this.sortStates = {};
    this.sortStatesProject = {};
    this.dateToday = moment();
    this.dateStart = this.dateToday;
    this.dateEnd = this.dateToday;
    this.dateStartChoice = this.dateToday;
    this.dateEndChoice = this.dateToday;
    this.isDateTodayOrLater = true;
    this.disabledEdition = false;
    this.billingTypes = [];

    this.checkTimeOverlapTimer;

    if (localStorage.getItem('roedl-dark-background')) {
      document.querySelector('body').classList.add('darkerBackground');
    }

    this.multiSelectSettings = {
      displayProp: 'name',
      showCheckAll: false,
      showUncheckAll: false,
      smartButtonMaxItems: 2,
      checkBoxes: true,
      scrollableHeight: 'auto',
      scrollable: true,
      enableSearch: false,
    };

    this.Auth.authorizePowerUser().then(
      async (user) => {
        this.user = user;

        if(!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then( newUserInfo => {
            this.user = newUserInfo;
            this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
            this.hasProjectsFlag = this.user.preferences.featureFlags.some(f => f == manuallyProjectsFlag || f == erpProjectsFlag);
            const todaysFlag = this.user.preferences.featureFlags.find(f => f == manuallyProjectsFlag) || this.user.preferences.featureFlags.find(f => f == erpProjectsFlag) || null;
            if (todaysFlag == manuallyProjectsFlag) this.todaysFlag = manuallyProjectsSource;
            else if (todaysFlag == erpProjectsFlag) this.todaysFlag = erpProjectsSource;
            else this.todaysFlag = null;
            this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");
          });
        } else {
          this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
          this.hasProjectsFlag = this.user.preferences.featureFlags.some(f => f == manuallyProjectsFlag || f == erpProjectsFlag);
          const todaysFlag = this.user.preferences.featureFlags.find(f => f == manuallyProjectsFlag) || this.user.preferences.featureFlags.find(f => f == erpProjectsFlag) || null;
          if (todaysFlag == manuallyProjectsFlag) this.todaysFlag = manuallyProjectsSource;
          else if (todaysFlag == erpProjectsFlag) this.todaysFlag = erpProjectsSource;
          else this.todaysFlag = null;
          this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");
        }

        // filter out project header (floatingHeaders) if no projects flag
        const filteredHeaders = this.headers && this.headers.filter(h => h.id !== "projectName");
        this.headers = this.hasProjectsFlag && this.headers || filteredHeaders;

        this.Stats.getUserMonthlySummary(this.dateToday.format("YYYY-MM")).then( // used to set day buttons (this.buttons)
          (success) => {
            this.userMonthlySummary = [...success.data[0].workdaySummaries, ...success.data[1].workdaySummaries];
            this.buttons = [];
            let todaysIndex = this.userMonthlySummary.findIndex( d => d.day == this.dateToday.format('YYYY-MM-DD'));
            this.buttons.push(this.userMonthlySummary[todaysIndex]);
            this.buttons.unshift(this.userMonthlySummary[todaysIndex-1]);
            let i = 1;

            if(!!this.userMonthlySummary[todaysIndex-i] && this.userMonthlySummary[todaysIndex-i].positionType == "Hourly") {
              // empty
            } else {
              while(!!this.userMonthlySummary[todaysIndex-i] && moment.duration(this.userMonthlySummary[todaysIndex-i].expectedWorknorm) == 0) {
                i=i+1;
                this.buttons.unshift(this.userMonthlySummary[todaysIndex-i]);
              }
            }

            this.buttons.filter(b => b).map( b => b.name = b.day && moment(b.day).format("DD.MM.YYYY"));
            this.setButtonAsActive();
          },
          (error) => {
            this.error = error;
            this.state = "error";
          }
        );

        this.clientsLoaded = false;

        await this.Work.getCountryBillingTypes()
          .then(({ data: { billingTypes }}) =>
            this.billingTypes = Object.entries(billingTypes).reduce((accu, curr) => {
              accu.push({id: curr[0], name: curr[1]});
              return accu;
            }, [])
          )
          .catch(error => {
            this.state = "error";
            this.error = error;
          });

        this.Work.getWorkspace().then(
          (workspaceData) => {
            this.workspace = workspaceData.data;
            if (!this.hasProjectsFlag) {
              this.clients = workspaceData.data.clients;

              this.clients.map(client => {
                if (client.additionalInfo)
                  client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.name}`;
              });
            }

            this.clientsLoaded = true;
            this.problems = {};
            this.workspace.problems.map((problem) => {
              this.problems[problem.id] = problem.name;
            });
          },
          (error) => {
            this.clientsLoaded = true;
            this.state = "error";
            this.error = error;
          }
        );

        if (this.hasProjectsFlag) {
          this.Work.getClientsWithFlagsHistory().then(
            (response) => {
              this.clients = response.data.clients || [];
              this.clients.map(client => {
                if (client.additionalInfo)
                  client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.name}`;
              });
              this.clientsLoaded = true;
              this.projectFlagHistory = response.data.projectFlagHistory || [];
            },
            (error) => {
              this.state = "error";
              this.error = error;
              this.clientsLoaded = true;
            }
          );
        }

        this.Stats.getWorklogsPU(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD")).then(
          (success) => {
            // get worklogs for the first time - date is loading from be - it must be set in datepicker

            this.isDateTodayOrLater = (angular.copy(this.dateToday).diff(this.dateStart, 'days') <= 0) || (angular.copy(this.dateToday).diff(this.dateEnd, 'days') <= 0);

            let usersWithEntries = [success.data.userWithEntries.find(u => u.user.id == this.user.id)];
            this.usersWithEntries = usersWithEntries;

            this.summary = this.deserializeData(usersWithEntries);
            this.state = "loaded";
            this.$scope.$apply();
          },
          (error) => {
            this.state = "error";
            this.stateWorklog = "error";
            this.error = error;
          }
        );

      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  getMoreData(day) {
    this.clearAllEditiedWorklogs(this.summary.users[0]);
    this.state = "loading";
    this.disabledEdition = false;
    if(day){
      this.dateStart = moment(day);
      this.dateEnd = moment(day);
    }
    this.isDateTodayOrLater  = (angular.copy(this.dateToday).diff(this.dateStart, 'days') <= 0) || (angular.copy(this.dateToday).diff(this.dateEnd, 'days') <= 0);
    this.refreshWorklog();
    this.setButtonAsActive();
  }

  setButtonAsActive() {
    this.buttons = this.buttons.filter(b => b).map( b => {
      let isActive = false;
      if(b.day && moment(b.day).isSame(this.dateStart , 'day') ) {
        isActive = true;
      }
      return {...b, active: isActive};
    });
  }

  deserializeData(usersWithEntries) {
    var users = usersWithEntries.map( userWithEntries => {
      var usersData = userWithEntries.entries
          .map((x) => {
            return this.deserializeWorklog(x);
          });

      if(usersData[usersData.length - 1]) {
        usersData[usersData.length - 1].isLastOne = true;
      }
      // Block last process also, because it can go after last interrupt
      var worklogList = usersData.filter((x) => x.type == "process");
      if(worklogList[worklogList.length - 1]) {
        worklogList[worklogList.length - 1].isLastOne = true;
      }
      const durationSum = usersData.reduce((accum, curr) => curr.duration.clone().add(accum), moment.duration(0));

      usersData.map(worklog => {
        if (worklog.additionalInfo)
          worklog.clientNameWithAdditionalInfo = `(${worklog.additionalInfo}) ${worklog.clientName}`;
      });

      return {
        name: userWithEntries.user.fullName,
        id: userWithEntries.user.id,
        allAccepted: usersData.filter((x) => x.approved || x.archived).length == usersData.length,
        visible: true,
        worklogs: usersData,
        isInCurrentTeam: userWithEntries.isInCurrentTeam,
        isBlocked: userWithEntries.user.blockedAt,
        durationSumText: this.$filter("hms")(durationSum.toJSON())
      };

    });
    users.sort((a,b) => a.name.localeCompare(b.name));
    var summary = {
      date: this.dateStart.format("YYYY-MM-DD")+ " — " +this.dateEnd.format("YYYY-MM-DD"),
      users: users
    };
    return summary;
  }

  deserializeWorklog(x) {
    x.startedAtTime = moment.utc(
      moment.parseZone(
        x.startedAt,
        ["YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DDTHH:mm:ssZ"]
      )
      .format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
    x.finishedAtTime = moment.parseZone(x.finishedAt, ["YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DDTHH:mm:ssZ"]);
    x.duration = moment.duration(x.duration);
    x.durationText = this.$filter("hms")(x.duration.toJSON());
    x.type = x.processName && "process" || "interrupt";
    x.isToday = x.startedAtTime.format("YYYY-MM-DD") == angular.copy(this.dateToday).format("YYYY-MM-DD");
    x.projectId = x.projectId || x.project && x.project.id || null;
    x.projectName = x.projectName || x.project && x.project.name || null;
    x.projectSource = x.projectSource || x.project && x.project.source || null;
    return x;
  }

  refreshWorklog() {
    this.clientsLoaded = false;
    this.Work.getWorkspace().then(
      (workspaceData) => {
        workspaceData.data.clients.map(client => {
          if (client.additionalInfo) {
            client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.name}`;
          } 
        });
        this.workspace = workspaceData.data;
        if (!this.hasProjectsFlag) this.clients = workspaceData.data.clients;
        this.clientsLoaded = true;
        this.problems = {};
        this.workspace.problems.map((problem) => {
          this.problems[problem.id] = problem.name;
        });
      },
      (error) => {
        this.clientsLoaded = true;
        this.error = error;
      }
    );
    if (this.hasProjectsFlag) {
      this.Work.getClientsWithFlagsHistory().then(
        (response) => {
          this.clients = response.data.clients || [];
          this.clients.map(client => {
            if (client.additionalInfo)
              client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.name}`;
          });
          this.clientsLoaded = true;
          this.projectFlagHistory = response.data.projectFlagHistory || [];
        },
        (error) => {
          this.clientsLoaded = true;
          this.error = error;
        }
      );
    }

    var previousSummary = angular.copy(this.summary);

    this.Stats.getWorklogsPU(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD")).then(
      (success) => {
        let usersWithEntries = [success.data.userWithEntries.find(u => u.user.id == this.user.id)];
        this.usersWithEntries = usersWithEntries;

        this.summary = this.deserializeData(usersWithEntries);

        if( previousSummary ) {
          this.summary.users.map((user) => {
            previousSummary.users.map((previousVersionOfUser) => {
              if(previousVersionOfUser.id == user.id) {
                user.visible = previousVersionOfUser.visible;
              }
            });
          });
        }
        setTimeout(() => { this.state = "loaded"; this.$scope.$apply();}, 10);
      },
      (error) => {
        this.state = "error";
        this.stateWorklog = "error";
        this.error = error;
      }
    );
  }

  anyClientSelectorExists(worklog) {
    return Boolean(
      worklog.clientSelector ||
      worklog.serviceLineSelector ||
      !!worklog.projectSelector ||
      worklog.processSelector
    );
  }

  cancelSelectedValue(worklog, fieldName) {
    switch (fieldName) {
      case 'projects':
        worklog.project = undefined;
        worklog.selectedProjectId = undefined;
        worklog.projectSelector = worklog.client ? "clientProjects" : "interruptProjects";
        break;
      case 'process':
        worklog.process = undefined;
        worklog.selectedProcessId = undefined;
        worklog.processSelector = true;
        worklog.outputType = undefined;
        worklog.outputs = undefined;
        break;
      case 'client':
        worklog.overtimeApplicationId = null;
        this.clearKeywordsArrays();
        this.selectClientStart(worklog);
        delete worklog.billingTypeId;
        delete worklog.billingTypeName;
        this.billingTypeOptions = null;
        break;
      case 'serviceLine':
        worklog.serviceLine = undefined;
        worklog.serviceLineSelector = true;
        break;
      default:
        break;
    }
  }

  editWorklogStart(worklog) {
    this.disabledEdition = false;
    worklog.previousVersion = angular.copy(worklog);
    worklog.previousVersion.volume = worklog.previousVersion.volume || null;
    worklog.edited = true;
    this.isEditing = true;
    worklog.oldDurationText = worklog.durationText;
    var newWorklog = {
      id: worklog.id,
      new: true,
      newDuration: worklog.duration,
      volume: worklog.volume,
      outputType: worklog.outputType,
      comment: worklog.comment,
      invoiceDetails: worklog.invoiceDetails,
      startDateChoice: worklog.startedAtTime.format("YYYY-MM-DD"),
      startTimeChoice: worklog.startedAtTime.format("HH:mm:ss"),
      startTimeMilliseconds: worklog.startedAtTime.format(".SSS"),
      durationText: this.$filter("hms")(worklog.duration.toJSON()),
      oldStartedAtTime: moment.utc(worklog.startedAtTime.format("YYYY-MM-DDTHH:mm:ss.SSS")),
      overtimeApplicationId: worklog.overtimeApplicationId,
      oldOvertimeApplicationId: worklog.overtimeApplicationId,
      billingTypeName: worklog.billingTypeName,
      billingTypeId: worklog.billingTypeId,
      clientMultiselectKeywords: worklog.clientMultiselectKeywords
    };

    if (worklog.billingTypeName) {
      newWorklog.billingTypeName = worklog.billingTypeName;
      newWorklog.billingTypeId = worklog.billingTypeId;
    }

    newWorklog.projectSource = this.setupWorklogSource(newWorklog.startDateChoice);

    const client = this.clients.filter(({ id }) => id == worklog.clientId)[0];
    const request = this.overtimeApplicationsFlag
      ? this.getPossibleApplicationsForUser(newWorklog, client)
      : Promise.resolve(newWorklog);

    this.$q.all([request]).then((success) => {
      newWorklog = angular.copy(success[0]);
      if(worklog.interruptCountryConfigurationId) {
        var interrupt = this.workspace.interrupts.filter(({id}) => id == worklog.interruptCountryConfigurationId)[0];
        if(worklog.clientId) {
          this.selectInterruptType(newWorklog, interrupt, 'client');
        } else if(worklog.serviceLine) {
          newWorklog.selectedProjectId = worklog.projectId;
          newWorklog.edited = true;
          this.isEditing = true;
          this.selectInterruptType(newWorklog, interrupt, 'serviceLine');
        } else {
          newWorklog.selectedProjectId = worklog.projectId;
          this.selectInterruptType(newWorklog, interrupt, 'none');
        }
      }
      if(worklog.clientId) {
        this.selectClient(newWorklog, client, true, worklog.previousVersion);
      }
      if(worklog.processClientConfigurationId) {
        newWorklog.selectedProcessId = worklog.processClientConfigurationId;
        this.selectProcess(newWorklog, true);
      }
      if(worklog.projectId && worklog.clientId) {
        newWorklog.selectedProjectId = worklog.projectId;
        this.selectProject(newWorklog);
      }

      angular.extend(worklog, newWorklog);
      worklog.valueAdded = worklog.previousVersion.valueAdded;
      window.lastEditedWorklog = worklog;
    });
  }

  selectClientStart(worklog) {
    worklog.clientMultiselectKeywords = null;
    worklog.client = undefined;
    worklog.project = undefined;
    worklog.projectName = undefined;
    worklog.projectId = undefined;
    worklog.selectedProjectId = undefined;
    worklog.clientSelector = true;
    worklog.projectSelector = undefined;
    worklog.applications = null;
    worklog.overtimeApplicationId = null;
  }

  createOrEditWorklogWithSplit() {
    const worklog = angular.copy(this.splitModalData.worklog);
    const user = angular.copy(this.splitModalData.user);

    worklog.splitOvertimeApplicationWorklog = true;

    this.splitModalData = null;
    this.splitModal = null;

    if (!worklog.id)
      return this.createWorklog(worklog, user);
    else
      return this.editWorklogSave(worklog, user);
  }

  editWorklogSave(worklog, user) {
    this.disabledEdition = false;
    worklog.saving = true;
    this.updateDuration(worklog, user, true);
    this.updateStartTime(worklog, user, true);
    this.Stats.saveWorklog(worklog).then((response) => {
      const newSecondWorklog = response.data.entries.find(entry => entry.id === response.data.secondNewId);

      this.usersWithEntries = this.usersWithEntries.map(user => {
        if (user.user.id == worklog.userId && newSecondWorklog) {
          user.entries.push(newSecondWorklog);
        }

        user.entries = user.entries
          .map(entry => {
            response.data.entries.map(responseEntry => {
              if (entry.id === worklog.id)
                worklog.id = entry.id = response.data.newId;

              if (entry.id == responseEntry.id) { 
                Object.keys(responseEntry).forEach(key => {
                  entry[key] = responseEntry[key];
                });
              }

              if (worklog.id === responseEntry.id && !responseEntry.overtimeApplicationId) {
                delete worklog.overtimeApplicationId;
                delete worklog.overtimeApplicationCode;
              }

              entry.saving = false;
              entry.edited = false;
              this.isEditing = false;
              entry.new = false;
              entry.error = false;
            });

            return entry;
          })
          .sort((entryA, entryB) => {
            const startedAtA = entryA.startedAt.slice(0, 19);
            const startedAtB = entryB.startedAt.slice(0, 19);

            return moment(startedAtA).valueOf() - moment(startedAtB).valueOf();
          });

        return user;
      });
      this.summary = this.deserializeData(this.usersWithEntries);
      this.clearKeywordsArrays();
      this.billingTypeOptions = null;
      delete worklog.previousVersion;
      this.$scope.$apply();
    }, (error) => {
      worklog.error = this.generateWorklogError(error.data);
      worklog.overlapError = error.data == "Processes overlap";
      worklog.saving = false;
      this.error = error;
      this.state = "error";
    });

  }

  editWorklogCancel(worklog) {
    this.disabledEdition = false;
    angular.extend(worklog, worklog.previousVersion);
    worklog.comment = worklog.previousVersion.comment;
    worklog.invoiceDetails = worklog.previousVersion.invoiceDetails;
    delete worklog.process;
    worklog.edited = false;
    this.isEditing = false;
    worklog.durationInvalid = false;
    worklog.error = null;
    worklog.new = false;
    worklog.client = false;
    worklog.clientSelector = false;
    worklog.serviceLineSelector = false;
    worklog.projectSelector = null;
    worklog.processSelector = false;
    worklog.startTimeFormatInvalid = null;
    worklog.alreadyAllocated = null;
    worklog.billingTypeName = worklog.previousVersion.billingTypeName;
    worklog.billingTypeId = worklog.previousVersion.billingTypeId;
    delete worklog.previousVersion;
    this.billingTypeOptions = null;
  }

  debounce(func, timeout = 300){
    return (...args) => {
      clearTimeout(this.checkTimeOverlapTimer);
      this.checkTimeOverlapTimer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  generateWorklogError(error) {
    if (!error.details)
      return error.message || this.$translate.instant("WORK_DATA.OVERLAP_ERROR");

    const errorDetails = error.details[0];

    if (!errorDetails)
      return error.message || this.$translate.instant("WORK_DATA.OVERLAP_ERROR");

    function formatDate(date) {
      return `${moment(date).format("YYYY-MM-DD")} ${date.slice(11).slice(0, 8)}`;
    }

    const errorEnding = `started ${formatDate(errorDetails.startedAt.replace(/\[.*\]/g, ''))} and finished ${formatDate(errorDetails.finishedAt.replace(/\[.*\]/g, ''))}.`;
    
    switch (errorDetails.errorType) {
      case 'EntriesOverlapPartially':
      case 'ProcessesOverlapPartially':
        return `Entry overlap partially with ${errorDetails.processName ? 'worklog' : 'interrupt'} ${errorEnding}`;
      case 'EditedInterruptWouldContain':
        return `Edited interrupt would contain other entry ${errorEnding}`;
      case 'EntryIsContainedByOtherEntries':
        return `Entry is contained by other ${errorDetails.processName ? 'worklog' : 'interrupt'} ${errorEnding}`;
      default:
        return this.$translate.instant("WORK_DATA.OVERLAP_ERROR");
    }
  }

  checkTimeOverlap(worklog, user) {
    if (!worklog.newDuration)
      return;

    if (worklog.id) {
      this.Stats.saveWorklogValidation(worklog).then(
        () => {
          worklog.alreadyAllocated = false;
          worklog.error = null;
          this.$scope.$apply();
        },
        (error) => {
          if (error.data.message === 'Overtime application was allocated') {
            worklog.alreadyAllocated = true;
            worklog.error = null;
            this.$scope.$apply();
          }
          else {
            worklog.error = this.generateWorklogError(error.data);
            this.$scope.$apply();
          }
        }
      );
    } else {
      this.Stats.createWorklogValidations(worklog, user).then(
        () => {
          worklog.error = null;
          this.$scope.$apply();
        },
        (error) => {
          worklog.error = this.generateWorklogError(error.data);
          this.$scope.$apply();
        }
      );
     }
  }

  updateDuration(worklog, user, wihtoutCheckTimeOverlap) {
    worklog.durationOverDaytime = false;
    worklog.alreadyAllocated = null;
    var format = /\d+:\d\d:\d\d/;
    var match = worklog.durationText.match(format);
    const previousDuration = worklog.previousVersion && worklog.previousVersion.duration;
    const previousDurationMatch = worklog.previousVersion && worklog.previousVersion.durationText.match(format);
    const isPreviousDurationMatchSameAsNewMatch = match && previousDurationMatch && match[0] == previousDurationMatch[0];
    if(match && match.length == 1) {
      const newDuration = moment.duration(match[0]);
      // handle miliseconds precision when no duration change
      worklog.newDuration = isPreviousDurationMatchSameAsNewMatch && previousDuration || newDuration;
      worklog.durationInvalid = false;
    } else {
      worklog.newDuration = undefined;
      worklog.durationInvalid = true;
    }

    this.checkDurationOverDaytime(worklog);

    if (!wihtoutCheckTimeOverlap) {
      this.debounce(() => this.checkTimeOverlap(worklog, user))();
    }
  }

  updateStartTime(worklog, user, wihtoutCheckTimeOverlap) {
    worklog.durationOverDaytime = false;
    worklog.startTimeFormatInvalid = false;
    worklog.alreadyAllocated = false;
    worklog.startedAtTime = moment.utc(worklog.startDateChoice + "T" + worklog.startTimeChoice + (worklog.startTimeMilliseconds || ''));
    const format = /\d\d+:\d\d:\d\d/;
    const match = worklog.startTimeChoice.match(format);
    
    if (!match) {
      worklog.startTimeFormatInvalid = true;
      return;
    }

    this.checkDurationOverDaytime(worklog);

    if (!wihtoutCheckTimeOverlap) {
      this.debounce(() => this.checkTimeOverlap(worklog, user))();
    }
  }

  acceptWorklog(worklog) {
    worklog.saving = true;
    this.Stats.acceptWorklog(worklog).then(() => {
      worklog.saving = false;
      worklog.edited = false;
      this.isEditing = false;
      worklog.approved = true;
      worklog.wasEdited = false;
      delete worklog.previousVersion;
    }, (error) => {
      worklog.error = this.generateWorklogError(error.data);
    });
  }

  declineWorklog(worklog) {
    this.modalConfig = {
      text: "WORK_DATA.DELETE_CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "DELETE"
    };
    this.bModal.show(this.modalConfig).then(() => {
      worklog.saving = true;
      this.Stats.declineWorklog(worklog).then((response) => {

        this.usersWithEntries = this.usersWithEntries.map(userWithEntries => {
          userWithEntries.entries = userWithEntries.entries
            .filter(entry => entry.id != worklog.id)
            .map(entry => {
              const updatedEntry = response.data.find(responseEntry => responseEntry.id === entry.id);
              if (updatedEntry)
                Object.keys(updatedEntry).forEach((key) => {
                  entry[key] = updatedEntry[key];
                });
    
              return entry;
            })
            .sort((entryA, entryB) => {
              const startedAtA = entryA.startedAt.slice(0, 19);
              const startedAtB = entryB.startedAt.slice(0, 19);
    
              return moment(startedAtA).valueOf() - moment(startedAtB).valueOf();
            });
          return userWithEntries;
        });
        this.summary = this.deserializeData(this.usersWithEntries);
        this.$scope.$apply();
      }, (err) => {
        if (err.data.message.includes('cannot be deleted due to settled application')) {
          worklog.saving = false;
          worklog.alreadySettledError = true;
        } else if (err.data.message.includes('cannot be deleted due to allocated application')) {
          worklog.saving = false;
          worklog.alreadyAllocatedError = true;
        } else
          worklog.error = this.generateWorklogError(err.data);
      });
    }, angular.noop);
  }

  acceptAllWorklogs(user) {
    user.worklogs
      .filter((x) => !x.edited || !x.saving || !x.archived)
      .map((x) => {
        this.acceptWorklog(x);
      });
    user.allAccepted = true;
  }

  setupWorklogSource(newWorklogStartDateChoice) {
    if (!this.projectFlagHistory) return null;

    const formattedProjectFlagHistory = this.projectFlagHistory.map(el => {
      return {
        start: el.start && moment(el.start).format("YYYY-MM-DD"),
        end: el.end ? moment(el.end).format("YYYY-MM-DD") : moment().add(1,"days").format("YYYY-MM-DD"), // if no endDate set in future
        flag: el.flag
      };
    });

    const flagsThatDay = formattedProjectFlagHistory.filter(el => {
      return moment(el.start).isSameOrBefore(moment(newWorklogStartDateChoice)) && moment(el.end).isSameOrAfter(moment(newWorklogStartDateChoice));
    });

    const lastFlagThatDay = flagsThatDay.length ? flagsThatDay[flagsThatDay.length-1].flag : null;

    if (lastFlagThatDay == manuallyProjectsFlag) return manuallyProjectsSource;
    if (lastFlagThatDay == erpProjectsFlag) return erpProjectsSource;
    if (lastFlagThatDay == "NoProjectFlag") return null;
  }

  /* CREATION FORM */

  newWorklog(user) {
    var worklogs = angular.copy(user.worklogs).sort((x, y) => x.finishedAtTime.diff(y.finishedAtTime));
    var lastWorklogOpt = worklogs[worklogs.length-1];

    user.adding = true;

    /*
      We are extracting the data from the LOCAL time provided by backend sooo...
      it's based on strings, because moment doesn't like local times.
    */
    // Choosing a date
    var startDateChoice = (lastWorklogOpt && lastWorklogOpt.finishedAtTime || angular.copy(this.dateEnd).add(8, "hours")).format("YYYY-MM-DD");

    // Choosing hour :-0
    var startTimeChoice = null;

    if(lastWorklogOpt && lastWorklogOpt.finishedAtTime) {
      var localLastFinishedAtTime = lastWorklogOpt.finishedAtTime._i.slice(11).slice(0,8);
      startTimeChoice = moment.duration(localLastFinishedAtTime).add(1, "second").format("HH:mm:ss");
    } else {
      startTimeChoice = "08:00:00";
    }

    var newWorklog = {
      durationOverDaytime: false,
      new: true,
      newDuration: moment.duration(),
      comment: "",
      invoiceDetails: null,
      addedManually: true,
      volume: 0,
      startDateChoice: startDateChoice,
      startTimeChoice: startTimeChoice == "24:00:00" ? "00:00:00" : startTimeChoice,
      startedAtTime: moment.utc(startDateChoice + "T" + startTimeChoice),
      durationText: "01:00:00"
    };

    newWorklog.projectSource = this.setupWorklogSource(newWorklog.startDateChoice);

    user.worklogs.push(newWorklog);

    this.checkDurationOverDaytime(newWorklog);
    this.clearAllEditiedWorklogs(user);
    this.disabledEdition = true;
  }

  checkDurationOverDaytime(worklog) {
    const dt = moment.duration(worklog.durationText);
    const duration = angular.copy(dt);

    const startedAtTimeDate = worklog.startedAtTime && angular.copy(worklog.startedAtTime).format("YYYY-MM-DD");
    const sumStartAndDurationDate = worklog.startedAtTime && angular.copy(worklog.startedAtTime).add(duration && duration.as('s'), "s").format("YYYY-MM-DD");

    if (startedAtTimeDate != sumStartAndDurationDate || startedAtTimeDate != worklog.startDateChoice) {
      worklog.durationOverDaytime = true;
    }
  }

  clearAllEditiedWorklogs({worklogs}) {
    worklogs.forEach( worklog => {
      if(worklog.edited) {
        this.editWorklogCancel(worklog);
      }
    });
  }

  removeNew(user, worklog) {
    this.disabledEdition = false;
    user.worklogs.splice(user.worklogs.indexOf(worklog), 1);
    user.adding = false;
    if (user.worklogs.length == 0) {
      this.dateEnd.subtract(8, "hours").subtract(1, "second");
    }
    this.clearKeywordsArrays();
    this.billingTypeOptions = null;
  }

  addNewInterrupt(worklog) {
    worklog.type = "interrupt";
  }

  addNewProcess(worklog) {
    worklog.type = "process";
    worklog.clientSelector = true;
  }

  hasSelectedClientNoProjects(worklog) {
    return Boolean(
      worklog.client.projectsToSelect &&
      worklog.client.projectsToSelect.length <= 0 &&
      !worklog.project
    );
  }

  shouldProcessBeSelected(worklog) {
    return Boolean(
      worklog.new &&
      worklog.client &&
      worklog.type == "process" &&
      !worklog.process
    );
  }

  filterProjectsToSelect(clientProjects, worklogDate, worklogSource) {
    return clientProjects
      .filter(project => project.source == worklogSource)
      .filter(p => !(p.status === "Archived" && moment(worklogDate).isAfter(moment(p.validUntil))));
  }

  getPossibleApplicationsForUser(worklog, client) {
    worklog.hasOvertimeApplicationInfo = false;
    worklog.applications = [];

    if (!client)
      return Promise.resolve(worklog);

    return this.OvertimeApplications.getPossibleApplicationsForEmployee(this.user.id, client.id, worklog.startDateChoice, worklog.id && worklog.overtimeApplicationId).then(
      (success) => {
        const applications = success.data;
        worklog.hasOvertimeApplicationInfo = true;
        const applicationIsFullySettled = worklog.overtimeApplicationId && !applications.some(application => application.id === worklog.overtimeApplicationId);

        if (applicationIsFullySettled) {
          worklog.applicationIsFullySettled = true;
          return worklog;
        }

        worklog.applications = applications.filter(application => (
          application.clients.includes(client.id)
          && (
            application.id === worklog.oldOvertimeApplicationId
              ? true
              : application.duration !== application.reportedDuration
          )
        ));

        return worklog;
      },
      (error) => {
        this.error = error;
        this.state = "error";
      }
    );
  }

  selectClient(worklog, client, alreadyHasApplications, previousVersion) {
    if (this.overtimeApplicationsFlag && !alreadyHasApplications)
      this.getPossibleApplicationsForUser(worklog, client);
    else {
      worklog.hasOvertimeApplicationInfo = true;
    }

    var processGroupLookup = {};
    this.workspace.processGroups.map((pg) => {processGroupLookup[pg.id] = pg;});
    var processesLookup = {};
    this.workspace.processes.map((p) => {processesLookup[p.id] = p;});

    var pccs = this.workspace.processClientConfigurations
      .filter( ({processId}) => processesLookup[processId] != undefined )
      .filter(({clientId}) => clientId == client.id)
      .filter( ({processId}) => processesLookup[processId].isHidden === false)
      .map((pcc) => {
        pcc.processName = processesLookup[pcc.processId].name;
        pcc.processGroupName = processGroupLookup[processesLookup[pcc.processId].processGroupId].name;
        return pcc;
      });
    client.processes = pccs;
    worklog.client = client;
    if (worklog.serviceLine) worklog.serviceLine = null;
    if(worklog.process) {
      var newProcessSearch = client.processes.filter(({processName}) => processName == worklog.process.processName);
      var newProcess = newProcessSearch[0] || undefined;
      worklog.process = newProcess;
      worklog.valueAdded = newProcess && newProcess.valueAdded;
    } else {
      delete worklog.process;
      delete worklog.valueAdded;
    }
    if (worklog.projectSource) {
      client.projectsToSelect = this.filterProjectsToSelect(client.projects, worklog.startDateChoice, worklog.projectSource);
      worklog.client = client;
      if (client.projectsToSelect.length > 0) worklog.projectSelector = "clientProjects";
    } else {
      client.projectsToSelect = [];
      worklog.client = client;
    }
    //set processSelector for no projectSource || new worklog when client has no projects || edited worklog when no process and client has projects
    worklog.processSelector = (!worklog.projectSource && !(worklog.process || worklog.interrupt)) ||
      (worklog.type == "process" && !worklog.process && this.hasSelectedClientNoProjects(worklog)) ||
      (worklog.type == "process" && !worklog.process && worklog.edited && !this.hasSelectedClientNoProjects(worklog));

    worklog.clientSelector = false;

    if (!worklog.interrupt || (worklog.interrupt && previousVersion && previousVersion.valueAdded)) {
      if (previousVersion && worklog.client.defaultBillingTypeId) {
        this.billingTypeOptions = cloneDeep(this.billingTypes);
        if (worklog.billingTypeId && !this.billingTypes.some(billingType => billingType.id === worklog.billingTypeId))
          this.billingTypeOptions.push({id: worklog.billingTypeId, name: worklog.billingTypeName});
      }
      if (!previousVersion && client.defaultBillingTypeId) {
        worklog.billingTypeId = client.defaultBillingTypeId;
        worklog.billingTypeName = client.defaultBillingTypeName;

        if (client.defaultBillingTypeId)
          this.billingTypeOptions = cloneDeep(this.billingTypes);
      }
    }

    if (worklog.client.multiselectKeywords && worklog.client.multiselectKeywords.length > 0) {
      const selectedKeywords = worklog.clientMultiselectKeywords && worklog.clientMultiselectKeywords.map(keyword => ({id: keyword, name: keyword})) || [];

      this.multiselectKeywords = new Array(
        ...worklog.client.multiselectKeywords.map(keyword => ({id: keyword, name: keyword})),
        ...selectedKeywords.filter(selectedKeyword => !worklog.client.multiselectKeywords.includes(selectedKeyword.id))
      );

      this.selectedKeywords = this.multiselectKeywords.filter(keyword => {
        return selectedKeywords.map(selectedKeyword => selectedKeyword.id).includes(keyword.id);
      });
    } else
      this.clearKeywordsArrays();
  }

  changeServiceLine(worklog) {
    worklog.serviceLineSelector = false;
  }

  selectProcess(worklog, edition) {
    worklog.process = worklog.client.processes.filter(({id}) => id == worklog.selectedProcessId)[0];
    worklog.valueAdded = worklog.process && worklog.process.valueAdded;
    worklog.processSelector = false;
    if (this.workspace.outputChoices[worklog.selectedProcessId]) {
      worklog.outputs = this.workspace.outputChoices[worklog.selectedProcessId].map(output => output.outputType);
      if(!worklog.outputType) { worklog.outputType = worklog.outputs[0]; }
    }
    else {
      const processInWorkspace = this.workspace.processes.find(process => worklog && worklog.process && worklog.process.processId === process.id);
      if (processInWorkspace.outputs && processInWorkspace.outputs.length) {
        worklog.outputs = processInWorkspace.outputs;
        if (worklog.outputType && !worklog.outputs.includes(worklog.outputType))
          worklog.outputs.unshift(worklog.outputType);
      }
    }

    if (!edition) {
      this.checkDurationOverDaytime(worklog);
    }
  }

  selectInterruptType(worklog, interrupt, type) {
    worklog.interrupt = interrupt;
    worklog.selectedInterruptType = type;

    if (type == "client") {
      worklog.clientSelector = true;
      worklog.serviceLineSelector = false;
    } else if (type == "serviceLine") {
      // new worklog no serviceLine
      if (!worklog.edited && !worklog.serviceLine) worklog.serviceLineSelector = true;

      // handle change from client interrupt to serviceLine interrupt
      if (worklog.edited && !worklog.serviceLine && worklog.wasEdited && !worklog.clientSelector) worklog.serviceLineSelector = true;

      worklog.interruptProjects = this.setupInterruptProjects(worklog);
    } else if (type == "none") {
      worklog.serviceLineSelector = false;
      worklog.interruptProjects = this.setupInterruptProjects(worklog);
    }
  }

  setupInterruptProjects(worklog) {
    let interruptProjects = [];
    if (worklog.projectSource) {
      const internalClient = this.clients && this.clients.find(cl => cl.name == "Internal");
      interruptProjects = internalClient ?
        this.filterProjectsToSelect(internalClient.projects, worklog.startDateChoice, worklog.projectSource) : [];

      if(!worklog.project && !worklog.selectedProjectId && interruptProjects.length > 0) {
        worklog.projectSelector = "interruptProjects";
      }
    }
    return interruptProjects;
  }

  showWideClientProjectSelector(worklog) {
    return Boolean(
      worklog.client &&
      worklog.projectSource &&
      !worklog.project &&
      worklog.type == 'process' &&
      !worklog.process &&
      !worklog.edited &&
      !worklog.processSelector
    );
  }

  isClientProjectSelector(worklog) {
    return Boolean(
      worklog.new &&
      !worklog.project &&
      worklog.client &&
      worklog.type
    );
  }

  isNoneOrSlProjectSelector(worklog) {
    return Boolean(
      worklog.new &&
      !worklog.project &&
      worklog.interrupt &&
      worklog.selectedInterruptType !== 'client' &&
      worklog.projectSelector == 'interruptProjects'
    );
  }

  selectProject(worklog) {
    if (worklog.type == 'interrupt' && (worklog.selectedInterruptType == 'none' || worklog.selectedInterruptType == 'serviceLine')) {
      worklog.project = worklog.interruptProjects && worklog.interruptProjects.filter(({id}) => id == worklog.selectedProjectId)[0];
      worklog.projectName = worklog.interruptProjects && worklog.project.name;
      worklog.projectId = worklog.interruptProjects && worklog.project.id;
    } else {
      const projectSelected = worklog.client.projects && worklog.client.projects.filter(({id}) => id == worklog.selectedProjectId)[0];
      worklog.project = projectSelected;
      worklog.projectName = projectSelected && projectSelected.name;
      worklog.projectId = projectSelected && projectSelected.id;

      // set processSelector when adding new worklog for client with project
      if (worklog.type == "process" && !worklog.process && !worklog.edited && worklog.selectedProjectId && worklog.project) {
        worklog.processSelector = true;
      }
    }
    worklog.projectSelector = undefined;
  }

  preCreateOrEditWorklog(worklog, user) {
    if (this.selectedKeywords)
      worklog.clientMultiselectKeywords = this.selectedKeywords.map(keyword => keyword.id);

    if (!worklog.overtimeApplicationId) {
      if (worklog.splitOvertimeApplicationWorklog === false)
        delete worklog.splitOvertimeApplicationWorklog;

      if (!worklog.id)
        return this.createWorklog(worklog, user);
      else
        return this.editWorklogSave(worklog, user);
    }

    const application = worklog.applications.find(application => application.id === worklog.overtimeApplicationId);
    let splitIsNeeded;

    if (application) {
      const leftDuration = moment.duration(application.duration)
        .subtract(moment.duration(application.reportedDuration))
        .add(worklog.oldOvertimeApplicationId === application.id ? moment.duration(worklog.oldDurationText) : 0);
      const durationChange = (!worklog.oldDurationText || worklog.oldDurationText === worklog.durationText)
        ? moment.duration(worklog.durationText)
        : moment.duration(worklog.oldDurationText).subtract(moment.duration(worklog.durationText));
      splitIsNeeded = moment.duration(leftDuration).subtract(durationChange).asMilliseconds() < 0;
    }

    if (splitIsNeeded) {
      this.splitModal = true;
      this.splitModalData = {
        worklog: worklog,
        user: user
      };
    } else {
      worklog.splitOvertimeApplicationWorklog = false;

      if (!worklog.id)
        return this.createWorklog(worklog, user);
      else
        return this.editWorklogSave(worklog, user);
    }
  }

  createWorklog(worklog, user) {
    this.disabledEdition = false;
    worklog.saving = true;
    this.updateDuration(worklog, user, true);
    this.updateStartTime(worklog, user, true);
    this.Stats.createWorklog(worklog, user).then((response) => {
      user.adding = false;
      worklog.saving = false;
      worklog.edited = false;
      this.isEditing = false;
      worklog.new = false;
      worklog.error = null;
      let newSecondWorklog;

      if (response.data) {
        const newWorklog = response.data.entries.find(entry => entry.id === response.data.newId);
        newSecondWorklog = response.data.entries.find(entry => entry.id === response.data.secondNewId);
        
        if (newWorklog)
          Object.keys(newWorklog).forEach((key) => {
            worklog[key] = newWorklog[key];
          });

        if (worklog.client && worklog.client.additionalInfo) {
          newWorklog.additionalInfo = worklog.client.additionalInfo;
        }
      }

      this.usersWithEntries = this.usersWithEntries.map((userWithWorklogs) => {
        if (userWithWorklogs.user.id == worklog.userId) {
          userWithWorklogs.entries.push(worklog);

          if (newSecondWorklog) {
            if (worklog.client && worklog.client.additionalInfo)
              newSecondWorklog.additionalInfo = worklog.client.additionalInfo;
            userWithWorklogs.entries.push(newSecondWorklog);
          }
        }

        userWithWorklogs.entries = userWithWorklogs.entries
          .map(entry => {
            const updatedEntry = response.data.entries.find(responseEntry => responseEntry.id === entry.id);
            if (updatedEntry)
              Object.keys(updatedEntry).forEach((key) => {
                entry[key] = updatedEntry[key];
              });

            return entry;
          })
          .sort((entryA, entryB) => {
            const startedAtA = entryA.startedAt.slice(0, 19);
            const startedAtB = entryB.startedAt.slice(0, 19);

            return moment(startedAtA).valueOf() - moment(startedAtB).valueOf();
          });
        return userWithWorklogs;
      });
      this.summary = this.deserializeData(this.usersWithEntries);
      this.billingTypeOptions = null;
      this.clearKeywordsArrays();
      this.$scope.$apply();
    }, (error) => {
      worklog.error = this.generateWorklogError(error.data);
      worklog.saving = false;
    });

  }

  handleSortStates(prevState, stateToSort, userId) {
    if(!prevState) {
      return stateToSort[userId] = "true";
    }
    if(prevState == "true") {
      return stateToSort[userId] = "reverse";
    }
    if(prevState == "reverse") {
      return stateToSort[userId] = undefined;
    }
  }

  worklogTableSortStateChange(user, column) {
    let prevState;
    if (column == 'clientName') {
      this.sortStatesProject = {};
      prevState = this.sortStates[user.id];
      this.handleSortStates(prevState, this.sortStates, user.id);
    }
    if (column == 'projectName') {
      this.sortStates = {};
      prevState = this.sortStatesProject[user.id];
      this.handleSortStates(prevState, this.sortStatesProject, user.id);
    }
  }

  cancelWorklog(worklog) {
    if (worklog.type === 'interrupt' && worklog.client)
      this.clearKeywordsArrays();

    worklog.interrupt = undefined;
    worklog.client = undefined;
    worklog.interruptName = undefined;
    worklog.project = undefined;
    worklog.projectId = undefined;
    worklog.projectName = undefined;
    worklog.selectedProjectId = undefined;
    worklog.selectedInterruptType = undefined;
    worklog.interruptProjects = undefined;
    worklog.clientSelector = false;
    worklog.projectSelector = undefined;
    this.billingTypeOptions = null;
    worklog.billingTypeId = null;
    worklog.billingTypeName = null;
  }
  addOutputs() {
    if (
      this.summary &&
      this.summary.users &&
      this.summary.users.length > 0 &&
      this.workspace &&
      this.workspace.processes &&
      this.workspace.processes.length > 0
    )
      this.summary.users = this.summary.users.map(user => {
        user.worklogs = user.worklogs.map(worklog => {
          var processInWorkspace = undefined;
          if (worklog.process) {
            processInWorkspace =
            this.workspace.processes.find(process => process.id == worklog.process.processId);
          }
          if (processInWorkspace && processInWorkspace.outputs && processInWorkspace.outputs.length) {
            worklog.outputs = processInWorkspace.outputs;
            if (worklog.outputType && !worklog.outputs.includes(worklog.outputType))
              worklog.outputs.unshift(worklog.outputType);
          }
          return worklog;
        });
        return user;
      });
  }

  displayMultiselectKeywords(clientMultiselectKeywords) {
    return clientMultiselectKeywords.join(', ');
  }

  clearKeywordsArrays() {
    this.multiselectKeywords = null;
    this.selectedKeywords = null;
  }

  valueAddedChangeHandler(worklog) {
    if (worklog.type === 'interrupt' && worklog.client && worklog.valueAdded) {
      this.billingTypeOptions = cloneDeep(this.billingTypes);
    }

    if (worklog.type === 'interrupt' &&  (!worklog.client || !worklog.valueAdded)) {
      this.billingTypeOptions = null;
    }
  }

  displaySelectedKeywordsInTitle(selectedKeywords) {
    return this.displayMultiselectKeywords(selectedKeywords.map(keyword => keyword.name));
  }
}
